import { getSavedItems } from "./getSavedItems";
import {
  getDisplayableItemCount,
  getSavedItems as getSavedItemsSelector
} from "../selectors";
import { ServiceError } from "../../../../services/errors";
import {
  BATCH_SIZE,
  LOAD_ITEMS_FAILURE,
  LOAD_ITEMS,
  RECEIVE_PAGINATION_ITEMS,
  SORT_INTENT
} from "../constants";
import { CLEAR_ERRORS_BY_TYPE, ERROR } from "../../common/constants";
import { isPlaceholder } from "../selectors/itemStateSelectors";
import clientConfigurationProvider from "../../../../providers/clientConfigurationProvider";

const getOffsetAndLimit = (index, items, totalSavedItemCount) => {
  const lowerBound = Math.max(0, index - BATCH_SIZE);
  const lowerLimitContribution = index - lowerBound + 1;
  const upperBound = Math.min(
    lowerBound + lowerLimitContribution + BATCH_SIZE - 1,
    totalSavedItemCount
  );
  const targetItems = items.slice(lowerBound, upperBound);
  const offset = lowerBound + targetItems.findIndex(isPlaceholder);
  const limit = targetItems.filter(isPlaceholder).length;

  return [offset, limit];
};

export const getSavedItemsAroundIndex =
  ({ index }) =>
  async (dispatch, getState) => {
    const state = getState();
    const items = [...getSavedItemsSelector(state)];
    const totalSavedItemCount = getDisplayableItemCount(state);
    const [offset, limit] = getOffsetAndLimit(
      index,
      items,
      totalSavedItemCount
    );
    const offsetId = items[offset].id;

    dispatch({ type: LOAD_ITEMS, payload: { offset, limit } });

    let savedItems;
    const { paginationGetItemsRetriesBackoff: retryBackoffs } =
      clientConfigurationProvider();
    try {
      savedItems = await dispatch(
        getSavedItems({ offset, limit, retryBackoffs, cancelInFlight: false })
      );
    } catch (e) {
      if (!(e instanceof ServiceError)) {
        throw e;
      }
      dispatch({
        type: CLEAR_ERRORS_BY_TYPE,
        payload: [LOAD_ITEMS, SORT_INTENT]
      });
      dispatch({
        type: LOAD_ITEMS_FAILURE,
        payload: { offset, limit, offsetId }
      });
      dispatch({
        type: ERROR,
        payload: {
          failedActionType: LOAD_ITEMS,
          canBeRetried: true,
          index
        }
      });

      return;
    }

    if (savedItems === null) {
      return;
    }

    dispatch({
      type: RECEIVE_PAGINATION_ITEMS,
      payload: {
        offset,
        limit,
        offsetId,
        savedItems
      }
    });
  };
